import { useQuery } from '@tanstack/react-query';

import { getSupplementalData } from '@arrived/api_v2';
import { AccountId, SupplementalData } from '@arrived/models';

import { MAX_STALE_TIME, UseQueryOptions } from '../queries.utils';
import { supplementalDataKeyFn } from './taxDocuments.keys';

export function useGetSupplementalDataQuery(
  year: number,
  accountId?: AccountId,
  options?: UseQueryOptions<SupplementalData>
) {
  return useQuery(supplementalDataKeyFn(accountId!, year), async () => getSupplementalData(accountId!, year), {
    ...options,
    enabled: (options?.enabled ?? true) && accountId != null,
    staleTime: options?.staleTime ?? MAX_STALE_TIME,
  });
}
